import RoutingConfig from './components/config/RoutingConfig';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css"
function App() {
  return (
   <>
     <RoutingConfig/>
     <ToastContainer/>
   </>
    
  );
}

export default App;
